<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Nueva tarea" />

    <tareanueva v-bind:idcolmenar="idcolmenar" v-bind:idcolmena="idcolmena" />

    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import tareanueva from "@/components/TaskNew"


export default {

    name: 'tarea-nueva',
    components: {
        toolbar,
        tareanueva,
    },
    data() {
        return {
            toolbar: {
                return: '0'
            },
             idcolmena: this.$route.params.idcolmena,
             idcolmenar: this.$route.params.idcolmenar,

        }
    },
    created() {
        auth.getUserLogged()
    }

};


</script>
